import { Input, Button } from "@ui";
import { Form, Formik } from "formik";
import style from "./ForgotPasswordPage.module.scss";
import * as Yup from 'yup';
import cn from "classnames"
import { useForgotPasswordMutation } from "@RTKQuery/user/auth/auth";
import { useEffect } from "react";

export function ForgotPasswordPage() {
    const [forgotPassword, { isSuccess, error, reset, isLoading }] = useForgotPasswordMutation();

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isSuccess) {
            timer = setTimeout(() => {
                reset();
            }, 15000);
        }

        return () => {
            clearTimeout(timer);
        }
    }, [isSuccess])

    return (
        <main className={style.page}>
            <p className={style.pageName}>Увійдіть в свій обліковий запис</p>
            <p className={style.message}>Нема проблем. Просто повідомте нам свою електронну адресу, і ми надішлемо Вам <span>посилання для скидання пароля</span>, яке дозволить Вам змінити пароль.</p>
            <p className={cn(style.message, style.success_message, "hidden")}>Ми надіслали на Вашу електронну адресу посилання для зміни пароля!</p>
            <Formik
                initialValues={{
                    email: "",
                }}
                validationSchema={Yup.object({
                    email: Yup.string().email("Неправильний формат пошти").required("Електронна пошта - обов'язкове поле"),
                })}
                onSubmit={({ email }) => {
                    forgotPassword({ email })
                }}
            >
                {(props) => (
                    <Form>
                        <Input
                            label="Електронна пошта"
                            type="text"
                            onChange={(newValue) => {
                                props.setFieldValue("email", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={String(props.values.email)}
                            name="email"
                            customStyle={{
                                width: "!max-w-[360px] !mb-[20px]"
                            }}
                            error={props.touched.email ? props.errors.email : ""}
                        />
                        <Button
                            type="submit"
                            color="blue"
                            text={isSuccess ? "Успішно надіслано" : "Отримати посилання"}
                            disabled={isSuccess}
                            customStyle={{
                                width: "!max-w-full !w-full",
                                button: "!max-w-full !w-full  !px-[45px] !h-[43px] !mb-[40px]",
                                text: "!text-[16px]"
                            }}
                            loading={isLoading}
                            errors={[
                                (error && ((extractError) => {
                                    return extractError(error)
                                }))
                            ]}
                            resetStatus={() => {
                                reset();
                            }}
                        />
                    </Form>
                )}
            </Formik>
        </main>
    )
}